export default "__VITE_ASSET__0TwmufJ$__"